import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { EmailDialogType } from "src/app/constants/email-dialog-type";
import { TableColumnType } from "src/app/constants/table";
import { EmailDocumentDialogModel } from "src/app/models/dialog";
import { AnnualStatementEmailCriteria, AnnualStatementsModel, StatementModel } from "src/app/models/payroll";
import { TableColumn } from "src/app/models/table";
import { HelperService } from "src/app/services/helper.service";
import { PayrollService } from "src/app/services/payroll.service";
import { DialogEmailDocumentComponent } from "../../shared/dialog/email-document.component";

@Component({
    selector: 'mwp-annual-statements',
    templateUrl: './annual-statements.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PayrollAnnualStatementsComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollAnnualStatements;

    public annualStatementsMatTableData: MatTableDataSource<AnnualStatementsModel>;



    public annualStatementsColumns: TableColumn[] = [
        {
            columnName: 'Email',
            propertyId: 'memberDocumentId',
            columnType: TableColumnType.button,
            dataTypeText: 'Email',
            width: '15%',
            cssCustomClass: 'mwp-button ignore-min-width',

        },
        {
            columnName: 'Annual Statement',
            propertyId: 'description',
            columnType: TableColumnType.hyperLink,
            dataTypePropertyId: '',
            isEmit: true,
        },
    ];


    constructor(
        private payrollService: PayrollService,
        private helperService: HelperService,
        private dialog: MatDialog,

    ) { }

    ngOnInit(): void {
        this.payrollService.getAnnualStatements().subscribe((response: Array<AnnualStatementsModel>) => {
            this.annualStatementsMatTableData = new MatTableDataSource(response);
        });
    }

    public DownloadFile(annualStatementsModel: AnnualStatementsModel): void {
        const l_StatementModel: StatementModel = new StatementModel();
        l_StatementModel.memberDocumentId = annualStatementsModel.memberDocumentId;

        this.payrollService.downloadAnnualStatementDocument(l_StatementModel).subscribe((response: Blob) => {
            let l_BinaryData: any = [];
            l_BinaryData.push(response);
            this.helperService.getBlobFormat(response).then((format) => {
                this.helperService.downloadDocument(l_BinaryData, response.type, `${annualStatementsModel.description}${format}`);
            });
        });
    }


    public emailDocument(annualStatementsModel: AnnualStatementsModel) {
        const dialogRef = this.dialog.open(DialogEmailDocumentComponent, {
            data: EmailDialogType.annualStatement,
            panelClass: 'mwp-modal-override-800'
        });

        dialogRef.afterClosed().subscribe((response: EmailDocumentDialogModel) => {
            if (response != null) {
                const l_AnnualStatementEmailCriteria = new AnnualStatementEmailCriteria();
                l_AnnualStatementEmailCriteria.annualStatementId = annualStatementsModel.memberDocumentId;
                l_AnnualStatementEmailCriteria.toAddress = response.email;
                this.payrollService.sendAnnualStatementToEmail(l_AnnualStatementEmailCriteria).subscribe(() => { });
            }
        });
    }
}
